import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
const AdhesionGak = /*#__PURE__*/ React.memo(({ safety = 'off', safetyState })=>{
    useAdUnit(AdProviders.Freestar, ADUNIT_MAP['AdhesionGam'], safety, safetyState, {
        targeting: {
            unitType: 'atf'
        }
    });
    // Unit has no chrome
    return null;
}, adunitMemo);
AdhesionGak.displayName = 'AdhesionGak';
export default AdhesionGak;
